// types
import { Control } from 'react-hook-form';

// components
import { Box, styled } from '@mui/material';
import {
  ControlledTextField,
  ControlledCheckbox,
  ControlledDatePicker
} from 'components/shared/ControlledFields';

// hooks
import { useTranslation } from 'react-i18next';

const SpacedBox = styled(Box)(({ theme }) => ({
  gap: theme.spacing(2.5),
  display: 'flex',
  flexDirection: 'column',
  paddingTop: theme.spacing(4)
}));

export const BaseDeclarationTypeSection = ({
  control
}: {
  control: Control<any>;
}) => {
  const { t } = useTranslation('common');
  return (
    <SpacedBox>
      <ControlledTextField
        name="name"
        control={control}
        variant="outlined"
        label={t('adminPortal.declarationTypes.name')}
        required
      />
      <ControlledCheckbox
        name="isDefault"
        control={control}
        label={t('adminPortal.declarationTypes.isDefault')}
      />
      <ControlledDatePicker
        name="validFrom"
        control={control}
        label={t('adminPortal.declarationTypes.validFrom')}
        required
        fullWidth
      />
      <ControlledDatePicker
        name="validTo"
        control={control}
        label={t('adminPortal.declarationTypes.validTo')}
        required
        fullWidth
      />
    </SpacedBox>
  );
};
